import { type QueryKey } from '@tanstack/react-query'
import { type TaskId, type TaskListInput, type TaskManagementInput } from '@terros/common'

export const taskKey = (taskId: TaskId): QueryKey => ['task', taskId]
export const taskListKey = (props?: TaskListInput): QueryKey => {
  if (!props) return ['tasks']
  return ['tasks', props]
}
export const taskManagementKey = (props?: TaskManagementInput): QueryKey => {
  if (!props) return ['task-management']
  return ['task-management', props]
}
